module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0096.jpg?v=c99a7e61";